



































































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import EditorWithFile from "@/components/EditorWithFile.vue";
import { TestQuestionCreate as ITestQuestionCreate } from "@/api/models/test-question-create";
import { TestQuestion as ITestQuestion } from "@/api/models/test-question";
import CustomButton from "@/components/form/CustomButton.vue";
import { TestAnswer as ITestAnswer } from "@/api/models/test-answer";
import TestQuestionManualForm from "@/components/tests/TestQuestionManualForm.vue";
import TestQuestionBufferForm from "@/components/tests/TestQuestionBufferForm.vue";
import CustomTable from "@/components/form/CustomTable.vue";
import CustomTableItem from "@/components/form/CustomTableItem.vue";
import CustomTableCol from "@/components/form/CustomTableCol.vue";
import TableActions from "@/components/form/TableActions.vue";
import TestQuestionsListItem from "@/components/tests/TestQuestionsListItem.vue";
import TestSortQuestions from "@/components/tests/TestSortQuestions.vue";
import { uniqBy } from "lodash";

@Component({
  components: {
    TestSortQuestions,
    TestQuestionsListItem,
    TableActions,
    CustomTableCol,
    CustomTableItem,
    CustomTable,
    TestQuestionBufferForm,
    TestQuestionManualForm,
    CustomButton,
    EditorWithFile
  }
})
export default class TestQuestionsList extends Vue {
  @Prop() existQuestions?: ITestQuestion[];
  @Prop() randomize?: boolean;
  @Prop() questionLoading?: boolean;
  questionList: Array<ITestQuestion | ITestQuestionCreate> = [];
  addQuestionMethod: "TestQuestionManualForm" | "TestQuestionBufferForm" | "" =
    "";
  showBlockEdit!: number | undefined;
  flag: boolean = false;
  questionsIdsToDeleted: Array<string> = [];
  isSorting: boolean = false;
  blockSorting: boolean = false;

  data() {
    return {
      question: undefined,
      showBlockEdit: undefined
    };
  }

  @Watch("isSorting")
  checkIsSorting() {
    if (!this.isSorting) {
      this.$emit("sortEnd");
    }
  }

  get questionsForCreate(): Array<ITestQuestionCreate> {
    return this.questionList.filter((el: any) => !el.id);
  }

  get questionsInStore() {
    return this.$store.getters["tests/TestsQuestions/GET_QUESTIONS"];
  }

  created() {
    if (
      !this.existQuestions &&
      this.questionsInStore.length &&
      this.$route.query.isSetQuestion === "true"
    ) {
      this.setQuestions();
    }
  }

  addQuestions(questions: Array<ITestQuestionCreate>) {
    this.blockSorting = true;
    this.questionList = [...this.questionList, ...questions];
    this.questionList.forEach((el, index) => {
      el.sort = index + 1;
    });
  }

  startToEdit() {
    this.addQuestionMethod = "";
    this.flag = !this.flag;
  }

  changeMethod(str: any) {
    this.flag = !this.flag;
    setTimeout(() => {
      this.addQuestionMethod = str;
    }, 300);
  }

  goToPrint() {
    window.print();
  }

  setQuestions() {
    this.questionsInStore?.forEach((el: ITestQuestion) => {
      let params: ITestQuestionCreate = {
        body: el.body,
        answers: el.answers.map((item: ITestAnswer) => {
          return { body: item.body, value: item.value, comment: item.comment };
        })
      };
      this.questionList.push(params);
    });
  }

  removeQuestion(index: number) {
    //@ts-ignore
    if (this.questionList[index]?.id) {
      //@ts-ignore
      this.questionsIdsToDeleted.push(this.questionList[index]?.id);
    }

    this.questionList.splice(index, 1);
    this.flag = !this.flag;
  }

  @Watch("existQuestions", { immediate: true })
  updateExistQuestion() {
    if (this.existQuestions) {
      this.questionList = [...this.existQuestions, ...this.questionList];
      this.questionList = uniqBy(this.questionList, "id");
    }
  }
}
